import axios from "axios";
import { Button, SelectBox, Template, TextBox, Validator } from "devextreme-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import * as editIcon from "./edit.svg";
import Profile from "../../common/Profile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { RequiredRule } from "devextreme-react/validator";
import { toastMsg } from "../utils";
// import { useSetRecoilState } from "recoil";
// import { partsInfoAtom } from "../../common/atoms";

const ViewTitle = styled.div`
  width: 100%;
  border-top: 1px solid #e6e6ea;
  padding: 8px 0px;
  font-size: 20px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .dx-button.dx-button-has-icon:not(.dx-button-has-text):not(.dx-shape-standard) {
    min-width: 26px;
    border-radius: 5px;
    margin: 0;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .dx-button-has-icon .dx-button-content {
    padding: 0;
  }
`;

const ViewBody = styled.div`
  display: flex;
  align-items: center;
  .dx-texteditor.dx-state-focused::before {
    border-bottom: 2px solid #007048 !important;
  }
  .dx-button.dx-button-has-icon:not(.dx-button-has-text):not(.dx-shape-standard) {
    border-radius: 5px;
    margin: 0px 0px 0px 8px;
    min-width: 26px;
    float: left;
    i {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .dx-button-has-icon .dx-button-content {
    padding: 0;
  }
  .dx-button-mode-outlined.dx-button-success.dx-button-has-icon {
    i {
      color: black;
    }
  }
  .dx-texteditor.dx-editor-filled .dx-texteditor-input {
    padding: 0;
  }
`;

const ViewButton = styled.span`
  display: inline-block;
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.textColor};
  text-align: center;
  padding: 6px 24px;
  font-weight: bold;
  white-space: nowrap;
  border-radius: 30px;
  &:hover {
    cursor: default;
  }
`;

const PartsBody = styled(ViewBody)`
  flex-wrap: wrap;
  > div {
    margin: 0px 8px 8px 0px;
  }
`;

const ViewBox = (props) => {
  const userInfo = useSelector((state) => state.userInfo);
  const { dataSource, id, info, infoRef, isAuthor, mode, setDetailsData, setPartsInfo, status, type } = props;
  const [infoValue, setInfoValue] = useState(info);
  const [isEditMode, setEditMode] = useState(false);
  // const setPartsInfo = useSetRecoilState(partsInfoAtom);

  const getTitleFromType = (type) => {
    return type === "topic"
      ? "Topic"
      : type === "cat"
      ? "Category"
      : type === "status"
      ? "Status"
      : type === "parts"
      ? "Participants"
      : "No Title";
  };

  const getDisplayExprFromDataSource = (type, value) => {
    const data = dataSource._array.find((el) => el.value === value);
    return (
      <ViewButton bgColor={data.hex || "#FAFAFA"} textColor={type === "topic" ? "white" : "black"}>
        {data.text}
      </ViewButton>
    );
  };

  const handleRenderField = (itemData) => {
    return (
      <div style={{ display: "flex", alignItems: "center", padding: "8px 16px", paddingLeft: "11px" }}>
        {itemData && itemData.hex ? (
          <FontAwesomeIcon icon={faCircle} style={{ color: `${itemData.hex}`, marginRight: "8px" }} />
        ) : (
          ""
        )}
        <TextBox defaultValue={itemData && itemData.text} height={"16px"} />
      </div>
    );
  };

  const handleRenderItem = (itemData) => {
    return (
      <div>
        {itemData.hex ? (
          <FontAwesomeIcon icon={faCircle} style={{ color: `${itemData.hex}`, marginRight: "8px" }} />
        ) : (
          ""
        )}
        {itemData.text}
      </div>
    );
  };

  const onClickEdit = () => {
    setEditMode(true);
  };

  const onClickUpdate = (e) => {
    const validationResult = e.validationGroup.validators.reduce((res, ele) => {
      if (ele._$element[0].id === `${type}SelectBox`) {
        const { isValid } = ele.validate();
        res = isValid;
      }
      return res;
    }, true);
    const newValue = infoRef.current.instance.option("value");

    if (validationResult && infoValue !== newValue) {
      axios
        .put(`${process.env.REACT_APP_BECCO_API_URL}/api/bbs/${type}/${id}`, {
          [type]: newValue,
          au: userInfo.employeeNo,
        })
        .then((res) => {
          if (type === "status") {
            setDetailsData(res.data);
            // 변경 후 참여자 정보 업데이트
            axios
              .get(`${process.env.REACT_APP_BECCO_API_URL}/api/bbs/pax/${id}`)
              .then((res) => {
                setPartsInfo(res.data);
                e.validationGroup.reset();
              })
              .catch((err) => {
                throw err;
              });
          }
          setInfoValue(newValue);
        })
        .then(() => {
          toastMsg(`${getTitleFromType(type)}${type === "topic" ? "이" : "가"} 변경되었습니다.`, true);
          setEditMode(false);
          e.validationGroup.reset();
        })
        .catch((err) => {
          toastMsg(`에러가 발생했습니다. 관리자에게 문의해주세요.`, false);
          setEditMode(false);
          throw err;
        });
    } else if (infoValue === newValue) {
      setEditMode(false);
    }
  };

  const onCancelUpdate = () => {
    setEditMode(false);
  };

  return (
    <>
      <ViewTitle>
        <span>{getTitleFromType(type)}</span>
        {((mode === "admin" && type !== "parts" && !isEditMode) ||
          (mode === "view" && type !== "status" && type !== "parts" && isAuthor && status === "1" && !isEditMode)) && (
          <Button
            id="editBtn"
            width={26}
            height={26}
            icon={`${editIcon.default}`}
            stylingMode="contained"
            onClick={onClickEdit}
          />
        )}
      </ViewTitle>
      <div style={{ minHeight: "96px" }}>
        {type === "parts" ? (
          <PartsBody>
            {dataSource.map((el) => (
              <Profile key={el} employeeNo={el} />
            ))}
          </PartsBody>
        ) : (
          // type === "topic", "cat", "status"
          <ViewBody>
            {
              // 새 글을 쓰거나 수정모드일 때만 SelectBox가 노출됨.
              isEditMode || mode === "create" ? (
                <SelectBox
                  dataSource={dataSource}
                  defaultValue={infoValue}
                  displayExpr={"text"}
                  fieldRender={handleRenderField}
                  id={`${type}SelectBox`}
                  itemRender={handleRenderItem}
                  ref={infoRef}
                  valueExpr={"value"}
                  width={"100%"}
                >
                  <Template name="statusHeaderFilter" render={handleRenderItem} />
                  <Validator>
                    <RequiredRule message={`${getTitleFromType(type)}은 필수항목입니다`} />
                  </Validator>
                </SelectBox>
              ) : (
                <div>{getDisplayExprFromDataSource(type, infoValue)}</div>
              )
            }

            {
              // 수정모드일 때만 제출, 취소버튼이 노출됨
              isEditMode && (
                <>
                  <Button
                    id="submitBtn"
                    width={26}
                    height={26}
                    icon="check"
                    type="success"
                    stylingMode="contained"
                    onClick={onClickUpdate}
                  />
                  <Button
                    id="cancelBtn"
                    width={26}
                    height={26}
                    icon="close"
                    type="success"
                    stylingMode="outlined"
                    onClick={onCancelUpdate}
                  />
                </>
              )
            }
          </ViewBody>
        )}
      </div>
    </>
  );
};

export default ViewBox;
